//#region src/services/IReleaseServicePublic.ts
const RELEASE_SERVICE_IDENT = "org.bloomstack.service.ReleaseService";

//#endregion
export { RELEASE_SERVICE_IDENT };
//# sourceMappingURL=IReleaseServicePublic.js.map